<span class="
  {{labelSize}}-label
  GothamSSm-{{labelWeight}}
  color-{{labelColor}}
"
>
  {{higLabel}}
</span>
